<template>
	<div id="m_infor">

		<div class="g-right-middle g-ypxx">
			<p>
				<span class='ypxx-left'><span class="font_2em">姓名</span></span>
				<span class="ypxx-right">
					<input type="text" v-model="name" placeholder="请输入联系姓名" />
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class='ypxx-left'><span class="font_3em">手机号</span></span>
				<span class="ypxx-right">
					<input type="text" v-model="mobile" placeholder="请输入联系手机号" />
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class='ypxx-left'><span class="font_3em">微信号</span></span>
				<span class="ypxx-right">
					<input type="text" v-model="wechat" placeholder="请输入联系微信号" />
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class='ypxx-left'><span class="font_qqem">qq号</span></span>
				<span class="ypxx-right">
					<input type="text" v-model="qqnumber" placeholder="请输入联系qq" />
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class='ypxx-left'><span class="font_2em">邮箱</span></span>
				<span class="ypxx-right">
					<input type="text" v-model="mail" placeholder="请输入联系邮箱" />
				</span>
				<div class=" clearfix"></div>
			</p>
			<!-- <p>
				<span class='ypxx-left'><span class="font_4em">联系角色</span></span>
				<span class="ypxx-right">
					<input type="text" v-model="role" placeholder="请输入联系角色" />
				</span>
				<div class=" clearfix"></div>
			</p> -->
			<center><input @click="ypxx" type="button" class="g-btn" value="确认提交"></center>
		</div>
	</div>
</template>
<script>
	import storage from '../../../storage/storage.js'
	import Axios from 'axios'
	export default {
		data() {
			return {
				name: storage.get('infor_name'),
				mobile: storage.get('infor_mobile'),
				wechat: storage.get('infor_wechat'),
				qqnumber: storage.get('infor_qqnumber'),
				mail: storage.get('infor_mail'),
				// role: storage.get('infor_role'),
				uid: ''
			}
		},
		mounted() {


		},
		methods: {

			ypxx() {
				var api = 'https://api.yopoo.cn/api/centre/updatecontact'  //联系方式修改接口

				let ypxxform = {
					name: this.name,
					mobile: this.mobile,
					wechat: this.wechat,
					qqnumber: this.qqnumber,
					mail: this.mail,
					// role: this.role,
					crew_id: storage.get('infor_crew_id'), //影片id
					id: storage.get('infor_id') //指定信息条数id
				}
				Axios.post(api, ypxxform).then((res) => {

					if (res.data.code == '200') {
						this.$message({ //提示发送验证码成功信息
							message: res.data.msg,
							type: 'success',
							center: true
						});

						setTimeout(() => { location.reload()}, 500);
						storage.del('uid') //清楚后台返回的存储uid信息
					}
					if (res.data.code == '202') {
						this.$message({ //提示发送验证码成功信息
							message: res.data.msg,
							type: 'error',
							center: true

						});
					}
				}).catch((res) => {

				})


			}
		}
	}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/group_admin/group_modify/M_Infor.vue